<template>
  <svg
    width="86"
    height="69"
    viewBox="0 0 86 69"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :class="$attrs.class"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.397 37.748C29.8199 37.7498 38.2708 29.3019 38.2727 18.8789C38.2745 8.45603 29.8265 0.00511302 19.4036 0.00329387C8.98069 0.00147471 0.529775 8.44944 0.527956 18.8724C0.526137 29.2953 8.9741 37.7462 19.397 37.748ZM64.8187 37.756C75.2416 37.7578 83.6926 29.3099 83.6944 18.8869C83.6962 8.46402 75.2482 0.0131056 64.8253 0.0112864C54.4024 0.00946728 45.9515 8.45743 45.9497 18.8803C45.9478 29.3033 54.3958 37.7542 64.8187 37.756ZM13.9487 67.0519L38.2657 28.0319L39.8945 29.047L15.5776 68.0669L13.9487 67.0519ZM83.9024 28.0407L59.5855 67.0607L61.2143 68.0757L85.5312 29.0558L83.9024 28.0407Z"
    />
  </svg>
</template>
